import { NavLink, useLocation } from 'react-router-dom';

const items = [
  { label: '首页', to: '/', icon: 'ri-home-5-line' },
  { label: '电影', to: '/category/movie', icon: 'ri-grid-line' },
  { label: '电视剧', to: '/category/tv', icon: 'ri-live-line' },
  { label: '搜索', to: '/search', icon: 'ri-search-line' },
];

export default function MobileTabBar() {
  const location = useLocation();

  const checkActive = (to: string) => {
    if (to === '/') return location.pathname === '/';
    return location.pathname.startsWith(to);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 md:hidden border-t border-background-200 bg-background-50/95 backdrop-blur">
      <div className="grid grid-cols-4">
        {items.map((item) => {
          const active = checkActive(item.to);
          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={`flex flex-col items-center gap-1 py-2.5 cursor-pointer ${
                active ? 'text-accent-600' : 'text-foreground-500'
              }`}
            >
              <span
                className={`flex h-7 w-7 items-center justify-center rounded-md ${
                  active ? 'bg-accent-100' : ''
                }`}
              >
                <i className={`${item.icon} text-lg w-5 h-5 flex items-center justify-center`} />
              </span>
              <span className="text-[11px] font-medium">{item.label}</span>
            </NavLink>
          );
        })}
      </div>
      <div className="h-[env(safe-area-inset-bottom)]" />
    </nav>
  );
}